import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container  maxWidth="xl">
        <Typography color='primary' style={{fontWeight:'bold'}} variant="body1" align="center">
          © {new Date().getFullYear()} Dimensions. All rights reserved.
        </Typography>
        <Typography style={{marginTop: -20}} color='primary' variant="body1" align="end">
          Powered By <Link  style={{textDecoration:'none', fontWeight:'bold'}} to="https://metavoria.com">Metavoria</Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
